import React from 'react';
import { useState, useEffect } from 'react';
import { Check, X } from 'lucide-react';

import { API_GET_LINKS } from '../../utils';

const Links = (props) => {
  const [links, setLinks] = useState(null);

  useEffect(() => {
    if (!links) {
      const clientSocialNetworksLinks = async (clientId) => {
        try {
          const { Links } = await (
            await fetch(API_GET_LINKS + new URLSearchParams({ clientId }))
          ).json();
          if (links === null) {
            setLinks(Links);
          }
        } catch (error) {
          console.error('The link have an error', error);
        }
      };
      if (props.selectedClient.id && links === null) {
        clientSocialNetworksLinks(props.selectedClient.id);
      }
    }
  }, [props.selectedClient.id, links]);

  return (
    <div className="flex items-center gap-3">
      {/* Facebook */}
      {props.facebook && (
        <div className="flex items-center gap-1.5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={links?.Facebook_URL}>
            <svg className="h-6 w-6" viewBox="0 0 24 24" fill="#1877F2">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
          </a>
          {props.statePost === 1 &&
            (props.facebookResponse ? (
              <Check className="h-5 w-5 text-green-600 stroke-[3]" />
            ) : (
              <X className="h-5 w-5 text-red-600 stroke-[3]" />
            ))}
        </div>
      )}

      {/* Google My Business */}
      {props.googleMyBusiness && (
        <div className="flex items-center gap-1.5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={
              links?.Google_Business_Listing_URL || links?.GMB_Google_2_URL
            }>
            <svg className="h-6 w-6" viewBox="0 0 24 24">
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
          </a>
          {props.statePost === 1 &&
            (props.gmbResponse ? (
              <Check className="h-5 w-5 text-green-600 stroke-[3]" />
            ) : (
              <X className="h-5 w-5 text-red-600 stroke-[3]" />
            ))}
        </div>
      )}

      {/* Twitter */}
      {props.twitter && (
        <div className="flex items-center gap-1.5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={links?.Twitter_URL}>
            <svg className="h-6 w-6" viewBox="0 0 24 24" fill="#1da1f2">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
            </svg>
          </a>
          {props.statePost === 1 &&
            (props.twResponse ? (
              <Check className="h-5 w-5 text-green-600 stroke-[3]" />
            ) : (
              <X className="h-5 w-5 text-red-600 stroke-[3]" />
            ))}
        </div>
      )}

      {/* Instagram */}
      {props.instagram && (
        <div className="flex items-center gap-1.5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={links?.Instagram_URL}>
            <svg className="h-6 w-6" viewBox="0 0 24 24">
              <defs>
                <linearGradient
                  id="ig-gradient"
                  x1="0%"
                  y1="100%"
                  x2="100%"
                  y2="0%">
                  <stop offset="0%" stopColor="#FFDC80" />
                  <stop offset="25%" stopColor="#F77737" />
                  <stop offset="50%" stopColor="#E1306C" />
                  <stop offset="75%" stopColor="#C13584" />
                  <stop offset="100%" stopColor="#833AB4" />
                </linearGradient>
              </defs>
              <rect
                width="22"
                height="22"
                x="1"
                y="1"
                rx="5"
                fill="url(#ig-gradient)"
              />
              <circle
                cx="12"
                cy="12"
                r="4.5"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
              />
              <circle cx="17.5" cy="6.5" r="1.2" fill="white" />
              <rect
                width="18"
                height="18"
                x="3"
                y="3"
                rx="3"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
          </a>
          {props.statePost === 1 &&
            (props.igResponse ? (
              <Check className="h-5 w-5 text-green-600 stroke-[3]" />
            ) : (
              <X className="h-5 w-5 text-red-600 stroke-[3]" />
            ))}
        </div>
      )}

      {/* TikTok */}
      {props.tiktok && (
        <div className="flex items-center gap-1.5">
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
          </svg>
          {props.statePost === 1 &&
            (props.tiktokResponse ? (
              <Check className="h-5 w-5 text-green-600 stroke-[3]" />
            ) : (
              <X className="h-5 w-5 text-red-600 stroke-[3]" />
            ))}
        </div>
      )}
    </div>
  );
};

export default Links;
